export default __webpack_public_path__ + "static/media/logout.90bc6f8d.svg";